import { GetTaxonHierarchyResponse, syliusFetch } from '../../@api/Sylius';
import { isFetchResultSuccessful } from '../../FetchResult/FetchResult';
import { TaxonWithParents } from './Taxon';
import { transformToTaxonWithParents } from './TaxonTransformers';

export const fetchTaxonHierarchy = async (mainTaxon: string): Promise<TaxonWithParents | undefined> => {
    const code = mainTaxon.replace('/api/v2/shop/taxons/', '');
    const taxonParentsResponse = await syliusFetch<GetTaxonHierarchyResponse>(`/shop/taxons/${code}/hierarchy`, {
        headers: {
            Accept: 'application/json',
        },
    });

    if (!isFetchResultSuccessful(taxonParentsResponse)) {
        return undefined;
    }

    const taxonParentsResource = taxonParentsResponse.data;

    return transformToTaxonWithParents(taxonParentsResource);
};

